import store from "../store";
import { UserApiData } from "../modules/security/models/user-model";
import { Institution } from "../models/institution-model";

export class LocalStorageHandler {
  /**
   * Generate localStorage key for department sequence
   * Format: departmentSequence-<logintype>_<userid>_<institutionid>
   */
  static getDepartmentSequenceKey(): string {
    const user = store.getters["security/getUser"]();
    
    if (!user?.id || !user?.login_type) {
      return "";
    }
    
    // Find current institution from user's institutions based on selected ID
    // (Using same logic as security/currentInstitution action but synchronously)
    let currentInstitution = user.institutioner?.find((i: Institution) => i.id === user.SelectedInstitutionId);
    
    // Fallback to first institution if none selected
    if (!currentInstitution && user.institutioner?.length > 0) {
      currentInstitution = user.institutioner[0];
    }
    
    if (!currentInstitution?.id) {
      return "";
    }
    
    return `departmentSequence-${user.login_type}_${user.id}_${currentInstitution.id}`;
  }

  /**
   * Save department sequence to localStorage
   */
  static saveDepartmentSequence(departmentIds: number[]): void {
    const storageKey = LocalStorageHandler.getDepartmentSequenceKey();
    if (!storageKey) return;
    
    try {
      localStorage.setItem(storageKey, JSON.stringify(departmentIds));
    } catch (error) {
      console.warn("Failed to save department sequence to localStorage:", error);
    }
  }

  /**
   * Load department sequence from localStorage
   */
  static loadDepartmentSequence(): number[] | null {
    const storageKey = LocalStorageHandler.getDepartmentSequenceKey();
    if (!storageKey) return null;
    
    try {
      const storedSequence = localStorage.getItem(storageKey);
      if (!storedSequence) return null;
      
      const departmentIds: number[] = JSON.parse(storedSequence);
      if (!Array.isArray(departmentIds)) return null;
      
      return departmentIds;
    } catch (error) {
      console.warn("Failed to load department sequence from localStorage:", error);
      return null;
    }
  }
}
